<template>
  <div>
    <a @click="$router.push('/simulados/novo')" href="javascript:void(0)" class="btn btn-novo float-right mb-3" v-if="false"><i class="fas fa-plus"></i> Criar novo simulado</a>

    <div class="row">
      <div class="col-12">
        <div class="tab-content bg-white">
          <div id="novo" class="tab-pane fade show active">
            <div class="input-group px-lg-5">
              <div class="d-flex align-items-center simulado-busca w-100">
                <i class="mdi mdi-magnify ml-3 mr-3"></i>
                <auto-complete
                  v-model="termoPesquisa"
                  inputClass="flex-grow-1"
                  :placeholder="'Buscar por ' + configEmpresa.textosConfiguraveis.textoDisplaySimulado"
                  :serializer="simulado => simulado.nome"
                  @hit="selecionarSimulado($event)"
                  :data="simuladosPaginados"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row px-lg-5">
      <div class="meus-sim col-12">
        <div class="row px-5 sem-resultados my-5" v-if="!simuladosPaginados.length && finalizados">
          <div class="col-12 my-5">
            <p>Você ainda não finalizou um <span class="text-lowercase">{{configEmpresa.textosConfiguraveis.textoDisplaySimulado}}</span>.</p>
            <p>
              <small>Comece um <span class="text-lowercase">{{configEmpresa.textosConfiguraveis.textoDisplaySimulado}}</span> ou finalize um em progresso para poder ver seus resultados.</small>
            </p>
          </div>
        </div>
        <div class="row px-5 sem-resultados my-5" v-if="!simuladosPaginados.length && !finalizados">
          <div class="col-12 my-5">
            <p>Você não tem <span class="text-lowercase">{{configEmpresa.textosConfiguraveis.textoDisplaySimulados}}</span> em progresso.</p>
            <p>
              <small>Não se preocupe em finalizar um <span class="text-lowercase">{{configEmpresa.textosConfiguraveis.textoDisplaySimulado}}</span>, continue quando quiser e acompanhe seu progresso.</small>
            </p>
          </div>
        </div>
        <div class="div-card-simulado">
          <div class="item-simulado-em-progresso d-flex flex-lg-row flex-column mb-3 w-100" v-for="(simulado, index) in simuladosPaginados" v-bind:key="index" :style="{'z-index': 51 - index}">
            <div class="col-lg-6 d-flex align-items-center">
              <div class="nome-simulado1">
                {{ simulado.nome }}
              </div>
            </div>
            <div class="col-lg-6 d-flex align-items-center justify-content-lg-end">
              <span class="questoes-simulado">{{ simulado.questoes }} questões</span>
            </div>
            <b-dropdown size="lg" right variant="link" toggle-class="text-decoration-none border-0" no-caret>
              <template #button-content>
                <i class="mdi mdi-dots-vertical"></i>
              </template>
              <b-dropdown-item href="javascript:void(0)" @click="irParaSimulado(simulado)" v-if="simulado.status !== 'Concluído'">{{ obterTextoBotaoSimulado(simulado) }}</b-dropdown-item>
              <b-dropdown-item href="javascript:void(0)" @click="zerarRecomecar(simulado.id)">Zerar e recomeçar</b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="col-12" v-if="simuladosPaginados.length">
            <div class="align-items-center d-flex flex-column flex-lg-row justify-content-end">
              <ul class="align-items-center d-flex pagination mb-2">
                <li class="page-item mr-2"><b>Mostrar</b></li>
                <li class="page-item" :class="{ active: pagination.itemsPerPage === 10 }">
                  <a class="page-link" @click="setItems(10)">10</a>
                </li>
                <li class="page-item" :class="{ active: pagination.itemsPerPage === 30 }">
                  <a class="page-link" @click="setItems(30)">30</a>
                </li>
                <li class="page-item" :class="{ active: pagination.itemsPerPage === 50 }">
                  <a class="page-link" @click="setItems(50)">50</a>
                </li>
              </ul>
              <nav class="ml-lg-5">
                <ul class="align-items-center d-flex pagination mb-2">
                  <li class="page-item mr-2"><b>Página</b></li>
                  <li class="page-item" v-for="(value, index) in pages" :key="value" :class="{ active: pagination.page == value }">
                    <a class="page-link" v-if="Math.abs(index - pagination.page) < 3 || index == pages - 1 || index == 0" @click="goToPage(value)">{{ value }}</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimuladoAPI from '@/api/simulado-api'
import ResponseUtils from '@/core/utils/response-utils'
import DateUtils, { DateConstants } from '@/core/utils/date-utils'
import AutoComplete from '@/core/components/autocomplete/AutoComplete'

export default {
  name: 'MeusSimulados',
  components: { AutoComplete },
  props: {
    finalizados: { type: Boolean, default: false }
  },
  data () {
    return {
      meusSimulados: [],
      termoPesquisa: '',
      pagination: {
        page: 1,
        total: 0,
        itemsPerPage: 10
      }
    }
  },

  mounted () {
    this.listarMeusSimulados()
    this.pagination.total = this.meusSimulados.length
  },

  computed: {
    configEmpresa: function () {
      return this.$store.getters.empresa
    },
    indexStart () {
      return (this.pagination.page - 1) * this.pagination.itemsPerPage
    },
    indexEnd () {
      return this.indexStart + this.pagination.itemsPerPage
    },
    pages () {
      return !this.meusSimulados.length ? 1 : Math.ceil(this.meusSimulados.length / this.pagination.itemsPerPage)
    },
    simuladosPaginados () {
      const simulados = this.meusSimulados
      return simulados.slice(this.indexStart, this.indexEnd)
    }
  },

  methods: {
    listarMeusSimulados: function () {
      const loader = this.$loading.show()

      SimuladoAPI.listarMeusSimulados().then(data => {
        if (data && data.length) {
          this.meusSimulados = [...data.filter(item => {
            return ((this.finalizados && item.fimPratica) || (!this.finalizados && !item.fimPratica))
          }).map(item => {
            return {
              id: item.idSimulado,
              nome: item.NomeSimulado,
              questoes: item.qtd_questoes,
              status: this.definirStatusSimulado(item),
              dataInicio: DateUtils.formatDate(item.inicioPratica, DateConstants.DD_MM_YYYY_HH_MM)
            }
          })].sort((sim1, sim2) => DateUtils.parse(sim2.dataInicio, DateConstants.DD_MM_YYYY_HH_MM).diff(DateUtils.parse(sim1.dataInicio, DateConstants.DD_MM_YYYY_HH_MM)))
        } else {
          this.meusSimulados = []
        }
        loader.hide()
      }).catch(error => ResponseUtils.handleError(error, loader))
    },

    definirStatusSimulado: simulado => simulado.fimPratica ? 'Concluído' : 'Em progresso',

    obterTextoBotaoSimulado: simulado => {
      switch (simulado.status) {
        case 'Novo': return 'Iniciar'
        case 'Concluído': return 'Refazer'
        default: return 'Continuar'
      }
    },

    irParaSimulado: function (simulado) {
      if (simulado.status === 'Concluído') {
        this.zerarRecomecar(simulado.id)
      } else {
        window.location = `/simulados/prova/${simulado.id}/questao/1`
      }
    },

    zerarRecomecar: function (simuladoId) {
      const loader = this.$loading.show()

      SimuladoAPI.refazer(simuladoId).then(() => {
        window.location = `/simulados/prova/${simuladoId}/questao/1`
      }).catch(error => ResponseUtils.handleError(error, loader))
    },

    setItems: function (items) {
      this.pagination.itemsPerPage = items
    },
    goToPage: function (page) {
      this.pagination.page = page
    }
  }
}
</script>

<style scoped>

</style>
